import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class IdleTimesService {
  idleTimes = [
    {
      value: 60,
      name: this.translate.instant('cluster.form.select.values.minutes', { number: 1 }),
    },
    {
      value: 600,
      name: this.translate.instant('cluster.form.select.values.minutes', { number: 10 }),
    },
    {
      value: 1800,
      name: this.translate.instant('cluster.form.select.values.minutes', { number: 30 }),
    },
    {
      value: 3600,
      name: this.translate.instant('cluster.form.select.values.hours', { number: 1 }),
    },
    {
      value: 14400,
      name: this.translate.instant('cluster.form.select.values.hours', { number: 4 }),
    },
    {
      value: 28800,
      name: this.translate.instant('cluster.form.select.values.hours', { number: 8 }),
    },
    {
      value: 43200,
      name: this.translate.instant('cluster.form.select.values.hours', { number: 12 }),
    },
    {
      value: 86400,
      name: this.translate.instant('cluster.form.select.values.days', { number: 1 }),
    },
    {
      value: 259200,
      name: this.translate.instant('cluster.form.select.values.days', { number: 3 }),
    },
    {
      value: 432000,
      name: this.translate.instant('cluster.form.select.values.days', { number: 5 }),
    },
    {
      value: 604800,
      name: this.translate.instant('cluster.form.select.values.days', { number: 7 }),
    },
  ];

  constructor(private translate: TranslateService) {}
}
